import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-62e962ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "txtSize12 federal-bar-links" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer15" }, null, -1))

import { useI18n } from "vue-i18n";

const __default__ = { name: "FooterBar" };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();
const currentYear = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("footer.bellcanada")) + " " + _toDisplayString(_unref(currentYear)) + ". " + _toDisplayString(_unref(t)("footer.allrightsreserved")), 1),
      _hoisted_4
    ])
  ]))
}
}

})